// extracted by mini-css-extract-plugin
export default {"materialsVideo":"MaterialsVideo_materialsVideo__g-qGA"};